<template>
  <div class="whoami p-4">
    <div class="flex flex-initial">
      <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">Who am
        I?</h3>
    </div>

    <div class="">
      <p>I'm a developer born in Iran and founder of Delix.ir, Bytegate.io and Bobet.ir and co-founder of
        Smo.li.</p>
      <p>I'm interested and skilled in different topics of Information Technology, including programming, web
        development, and computer and network security.</p>
    </div>
  </div>
</template>

<script>
export default {
name: "Introduction",
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">

</style>
